"use client";

import { c as _c } from "react/compiler-runtime";
import EnquirySheetShell from "@/components/get-in-touch/EnquirySheetShell";
import SurveyBody from "./SurveyBody";
import { useSurveySheetStore } from "@/store/surveySheetStore";
import { leaveFlow } from "@/components/get-in-touch/enquiryFlowHistory";

// Standalone project-details survey sidesheet, for any caller OTHER than
// the enquiry flow (which instead hosts SurveyBody inline via
// EnquiryFlowShell, sliding between steps instead of popping its own
// separate sheet). Has no knowledge of who opened it or what happens next —
// whoever calls useSurveySheetStore().open() supplies onComplete/onSkip and
// gets called back with the answers.
export default function SurveySheet() {
  const $ = _c(5);
  const isOpen = useSurveySheetStore(_temp);
  const context = useSurveySheetStore(_temp2);
  const isStandalone = isOpen && context !== "enquiryFlow";
  let t0;
  if ($[0] !== isStandalone) {
    t0 = <SurveyBody isActive={isStandalone} />;
    $[0] = isStandalone;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isStandalone || $[3] !== t0) {
    t1 = <EnquirySheetShell open={isStandalone} onClose={_temp3} width={480}>{t0}</EnquirySheetShell>;
    $[2] = isStandalone;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp3() {
  return leaveFlow();
}
function _temp2(state_0) {
  return state_0.context;
}
function _temp(state) {
  return state.isOpen;
}